import { WizardLayoutItem } from './models/wizard-data'

export class WizardUtil {
  public static hasValue(wizardItem: WizardLayoutItem) {
    // if (wizardItem.type === DROP_DOWN || wizardItem.type === STRING_INPUT) {
    return !!wizardItem.value
    // }
    // return false;
  }

  public static getValue(wizardItem: WizardLayoutItem) {
    // if (wizardItem.type === DROP_DOWN || wizardItem.type === STRING_INPUT) {
    return wizardItem.value
    // }
    // return null;
  }
}
